import styled from "styled-components";

export const Container = styled.div `

    margin-top: 30px;
    
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;
    }

    header h2 {
        margin: 0 !important;
    }
    
    header div {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    header button {
        background: unset;
        color: #fff;
        height: 40px;
        width: 40px;
        border-radius: 50px;
        border: none;
        cursor: pointer;
        font-size: 1.1rem;
        transition: all .3s ease;
    }

    header button:hover {
        background: #303030;
    }

    header button:first-child {
        margin-right: 5px;
    }

    header .active {
        background: #fff;
        color: #181818;
    }

    header .active:hover {
        cursor: default;
        background: #fff;
    }

    .container-movies {
        display: ${props => props.layoutStyle == 'grid' ? 'grid' : 'flex'};
        flex-direction: column;
        grid-template-columns: repeat(4, 1fr);
        gap:  ${props => props.layoutStyle == 'grid' ? '10px' : '0'};
    }

    .movie {
        display: ${props => props.layoutStyle == 'grid' ? 'block' : 'flex'};
        color: #fff;
        text-decoration: none;
        padding: ${props => props.layoutStyle == 'grid' ? '10px' : '30px 10px'};
        border-bottom: ${props => props.layoutStyle == 'grid' ? 'none' : '2px solid #505050'};
        border-radius: 5px;
        background-color: ${props => props.isDisabled ? "#f00 !important" : 1};
        transition: all .3s ease;
    }

    .movie:hover {
        background: #00000050;
    }

    .container-image {
        position: relative;
        margin-bottom: 10px;
    }

    .container-image img {
        border-radius: 5px;
        min-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '300px'};
        max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '300px'};
        width: 100%;
        height: auto;
        background-color: #252525;
        aspect-ratio: 16/9;
        object-fit: cover;
    }

    .movie .details {
        margin-left: ${props => props.layoutStyle == 'grid' ? '' : '20px'};
    }

    .movie .details .name {
        font-size: 1.1rem;
        overflow: hidden;
        font-weight: bold;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .movie .details section {
        margin: 5px 0 10px 0;
    }

    .movie .details section span {
        margin-right: 10px;
        font-size: .85rem;
        font-weight: 600;
        color: #fff;
    }

    .movie .details .name span {
        margin-right: 10px;
    }

    .movie .details .overview {
        font-size: .85rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        color: #fff;
        -webkit-box-orient: vertical;
    }
    
    .no-suggestions {
        padding: 30px 0;
        text-align: center;
        font-size: 1.2rem;
        color: #ccc;
    }

    @media(max-width: 1500px) {
        .container-movies {
            grid-template-columns: repeat(4, 1fr);
        }
    }
    
    @media(max-width: 1000px) {
        .container-movies {
            grid-template-columns: repeat(3, 1fr);
        }
    }
    
    @media(max-width: 330px) {
        .container-movies {
            grid-template-columns: repeat(1, 1fr);
        }
    }

    @media (max-width: 1000px) {

        .movie {
            padding: ${props => props.layoutStyle == 'grid' ? '10px' : '20px 5px'};
        }

        .movie img {
            min-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '200px'};
            max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '200px'};
        }

        .movie .details {
            margin-left: ${props => props.layoutStyle == 'grid' ? '' : '20px'};
        }

        .movie .details .name {
            font-size: 1rem;
        }

        .movie .details section span {
            font-size: .7rem;
        }

        .movie .details .overview {
            font-size: .75rem;
        }

    }

    @media (max-width: 800px) {

        .movie img {
            min-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '160px'};
            max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '160px'};
        }

        .movie .details .name {
            margin-top: 0 !important;
        }

    }

    @media (max-width: 600px) {

        .container-movies {
            gap: 20px
        }
            
        header {
            flex-direction: column;
            align-items: start;
        }

        header button {
            height: 30px;
            width: 30px;
            font-size: .9rem;
        }

        .movie {
            padding: ${props => props.layoutStyle == 'grid' ? '10px' : '20px 5px'};
        }

        .container-image {
            margin-bottom: 5px;
        }

        .movie img {
            min-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '140px'};
            max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '140px'};
        }

        .container-movies {
            grid-template-columns: repeat(2, 1fr);
        }

        .movie .details {
            margin-left: ${props => props.layoutStyle == 'grid' ? '' : '20px'};
        }

        .movie .details .name {
            font-size: .85rem;
            -webkit-line-clamp: 2;
        }

        .movie .details section span {
            font-size: .65rem;
        }

        .movie .details .overview {
            font-size: .65rem;
            -webkit-line-clamp: 2;
        }
    
        .no-suggestions {
            font-size: .9rem;
        }

    }

    @media (max-width: 550px) {

        .container-movies {
            gap:  ${props => props.layoutStyle == 'grid' ? '20px 5px' : '0'};
        }

        .movie {
            padding: ${props => props.layoutStyle == 'grid' ? '5px' : '15px 5px'};
        }

        .movie img {
            aspect-ratio: 16/9;
            min-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '120px'};
            max-width: ${props => props.layoutStyle == 'grid' ? 'unset' : '120px'};
        }

        .movie .details {
            margin-left: ${props => props.layoutStyle == 'grid' ? '' : '10px'};
        }

        .movie .details .name {
            font-size: .75rem;
        }

        .movie .details section {
            margin: 0 0 5px 0;
        }

        .movie .details section span {
            font-size: .6rem;
        }

        .movie .details .overview {
            font-size: .6rem;
        }

    }

`